import { ExpenseBarChart } from "./ExpenseBarChart";
import { ExpenseChartSelectionDate } from "./ExpenseChartSelectionDate";

export const ExpenseChartSection = () => {
  return (
    <section className="expense-chart mt-4 touch-none">
      <ExpenseBarChart />
      <ExpenseChartSelectionDate />
    </section>
  );
};
